import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SuggestedUnsubscribe"*/ './lazyIndex')
);

// Init/Generate
export const lazyCreateSuggestedUnsubscribeItems = new LazyAction(
    lazyModule,
    m => m.createSuggestedUnsubscribeItems
);

// Lazy actions
export const lazyRemoveSuggestedUnsubscribeItem = new LazyAction(
    lazyModule,
    m => m.removeSuggestedUnsubscribeItem
);

export const lazyUpdateAllowList = new LazyAction(lazyModule, m => m.updateAllowList);

export const lazySetSuggestionShown = new LazyAction(lazyModule, m => m.setSuggestionShown);
